module.exports = __webpack_public_path__ + "img/49-l.d33d9ca6.png";